import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Tabs, Tab, Box, AppBar, Toolbar, Typography } from "@mui/material";
import { adminPanelTabs } from "./adminPanelTabs";
import TabPanel from "../../../components/Tabs/TabPanel.component";
import paths from "../../../api/paths.api";

const tabs = adminPanelTabs();

export default function AdminPanel() {
  const navigate = useNavigate();
  const { subPanel } = useParams();

  const [value, setValue] = React.useState(() => subPanel || tabs[0].label);

  React.useEffect(() => {
    setValue(subPanel);
  }, [subPanel]);

  const handleChange = (_, newValue) => {
    navigate(`${paths.adminPanel}/${newValue}`);
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <AppBar position="static" elevation={1}>
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            Admin Panel
          </Typography>
        </Toolbar>
      </AppBar>

      <Tabs value={value} onChange={handleChange} orientation={"horizontal"}>
        {tabs.map((tab, i) => {
          return (
            <Tab
              icon={tab.icon}
              iconPosition="start"
              label={tab.label}
              value={tab.id}
              key={tab.label}
            />
          );
        })}
      </Tabs>

      {tabs.map((t, i) => {
        return (
          <TabPanel value={value} index={t.id} key={t.label}>
            {t.panel}
          </TabPanel>
        );
      })}
    </Box>
  );
}
